export class OperacionGenericaDto {
  Observacion: String;
  estadoOperacion: String;
}
